module.exports = __webpack_public_path__ + "static/media/birthday2023_bg.14e09dcd.jpg";